export default __webpack_public_path__ + "static/media/presenceIconEmpty.88adba23.svg";